/* eslint-disable no-console */
const memexFunctions = {
  install(Vue) {
    Vue.mixin({
      methods: {

        
async postaxiosResponse(url, oggettodainserire) {
  console.log("postaxiosResponse",url, oggettodainserire)
  var access_token = this.$store.getters.getToken;
  if (access_token) {
    var headers = {
      headers: { 'x-access-token': "Bearer " + access_token, Accept:"*/*"  }
    };
    try {

      let response = await this.$axios.post(
        url,
        oggettodainserire,
        headers
      );
      //let response = await this.$axios.get( url);
      //if (response.status === 200) {
        this.submitted = true;
        return response;
      //}
    } catch (error) {
      console.log(error.response)
      if (error.response.status === 400) {
        this.error = "Incorrect credentials, please try again";
        throw error
      }
      else if (error.response.status === 403) {
        this.$store.dispatch("logout");
        this.$router.push('/login')
      } 
      else {
        this.error = "An error has occurred";
        // eslint-disable-next-line
        //console.log(error.response);
        throw error
      }
    }
  } else {
    console.log("missing token 1");
    this.$store.dispatch("logout");
    this.$router.push('/login')
  }
},

//---
async putaxiosResponse(url, oggettodainserire) {
  var access_token = this.$store.getters.getToken;
  if (access_token) {
    var headers = {
      headers: { 'x-access-token': "Bearer " + access_token }
    };
    try {

      let response = await this.$axios.put(
        url,
        oggettodainserire,
        headers
      );
      //let response = await this.$axios.get( url);
      //if (response.status === 200) {
        this.submitted = true;
        return response;
      //}
    } catch (error) {
      console.log(error.response.status)
      if (error.response.status === 400) {
        this.error = "Incorrect credentials, please try again";
        //console.log("Incorrect credentials, please try again")
        throw error
      }
      else if (error.response.status === 403) {
      //console.log("Token Expired")
      this.$store.dispatch("logout");
      this.$router.push('/login')
    }
      else {
        this.error = "An error has occurred";
        throw error
        // eslint-disable-next-line
      }
    }
  } else {
    console.log("missing token 2");
  this.$store.dispatch("logout").then(()=>
  this.$router.push('/login'))
  }
},

        async getaxiosResponse(url) {
          var access_token = this.$store.getters.getAccessToken;

          if (access_token) {
            var headers = {
              headers: { 'x-access-token': "Bearer " + access_token }
            };
            try {

              let response = await this.$axios.get(
                url,
                //{ withCredentials: true },
                headers
              );
              //let response = await this.$axios.get( url);
              //if (response.status === 200) {
                this.submitted = true;
                return response;
              //}
            } catch (error) {
              console.log(error.response)
              if (error.response.status === 400) {
                this.error = "Incorrect credentials, please try again";
                throw error
              }
              else if (error.response.status === 403) {
                this.$store.dispatch("logout");
                this.$router.push('/login')
              } 
              else {
                this.error = "An error has occurred";
                // eslint-disable-next-line
                throw error
              }
            }
          } else {
            console.log("missing token 3");
            this.$store.dispatch("logout").then(()=>
            this.$router.push('/login'))
          }
        },

        async getaxiosResponseNoBearerToken(url) {
            try {

              let response = await this.$axios.get(
                url
              );
              if (response.status === 200) {
                this.submitted = true;
                return response.data.response;
              }
            } catch (error) {
              console.log(error.response)
              if (error.response.status === 400) {
                this.error = "Incorrect credentials, please try again";
                throw error
              }
              else if (error.response.status === 403) {
                this.$store.dispatch("logout");
                this.$router.push('/login')
              } 
              else {
                this.error = "An error has occurred";
                // eslint-disable-next-line
                throw error
              }
            }
        },
        // this method filters an object based on a pair of key value objects to be filtered
        filterRawObject(oggettoDaFiltrare, coppiaDiValoriDaFiltrare) {
          var found;
          const oggettoFiltrato = oggettoDaFiltrare.filter(function(element) {
            found = true;
            for (const [key, values] of Object.entries(
              coppiaDiValoriDaFiltrare
            )) {
              if (
                key != "distributorInventory" &&
                coppiaDiValoriDaFiltrare[key] &&
                found
              ) {
                found = values.indexOf(element[key]) > -1 ? true : false;
              }
              if (coppiaDiValoriDaFiltrare.distributorInventory && found) {
                if(typeof(coppiaDiValoriDaFiltrare.distributorInventory.min) == 'number' && coppiaDiValoriDaFiltrare.distributorInventory.max == '' ){
                  found =
                    (element.distributorInventory >= coppiaDiValoriDaFiltrare.distributorInventory.min)
                      ? true
                      : false;
                }
                else if(typeof(coppiaDiValoriDaFiltrare.distributorInventory.max) == 'number' && coppiaDiValoriDaFiltrare.distributorInventory.min == ''){
                  found =
                    (element.distributorInventory <= coppiaDiValoriDaFiltrare.distributorInventory.max)
                      ? true
                      : false;
                }
                else if(typeof(coppiaDiValoriDaFiltrare.distributorInventory.max) == 'number' && typeof(coppiaDiValoriDaFiltrare.distributorInventory.min) == 'number'){

                found =
                  (element.distributorInventory >= coppiaDiValoriDaFiltrare.distributorInventory.min && element.distributorInventory <= coppiaDiValoriDaFiltrare.distributorInventory.max)
                    ? true
                    : false;
              }
            }
            }
            return found;
          });
          return oggettoFiltrato;
        },

        mapRawObjectDistinctLabel(oggettoDaFiltrare, parametrodafiltrare) {
          let unique = [
            ...new Set(
              this[oggettoDaFiltrare].map(item => item[parametrodafiltrare])
            )
          ];

          return unique;
        },
        //truncate a string too long
        truncate(str, n,m){
          //this.$store.getters.getToken
          if (this.$route.name=='home'){
          if (this.$store.getters.getIsCreatedOrviewStories==false){
          return (str.length > n) ? str.substr(0, n-1) + '...' : str;
          }else{
            return (str.length > m) ? str.substr(0, m-1) + '...' : str;
            
          }
          }else{
            return str
          }
        },

      }
    });
  }
};

export default memexFunctions;
